// ***********************************************************************
// Assembly         : Veriteq.Partner.Web
// Author           : Mike Palmer
// Created          : 06-28-2024
//
// Last Modified By : Mike Palmer
// Last Modified On : 06-28-2024
// ***********************************************************************
// <copyright file="dropdown.js" company="NSA Group Ltd">
//     Copyright (c) NSA Group Ltd. All rights reserved.
// </copyright>
// <summary>
//     JavaScript utility for handling clicks outside of a specified DOM element
//     to trigger a .NET method call in a Blazor application.
// </summary>
// ***********************************************************************

window.dropdown = window.dropdown || {};

/**
 * Attaches an event listener to detect clicks outside of a specified DOM element.
 * When a click outside the element is detected, the specified .NET method is invoked
 * asynchronously using Blazor's JS interop.
 *
 * @function handleClickOutside
 * @memberof window.dropdown
 * @param {object} dotNetHelper - The .NET object reference used to invoke .NET methods from JavaScript.
 * @param {string} elementId - The ID of the DOM element to monitor for outside clicks.
 * @returns {function} A function that removes the event listener when invoked.
 */
window.dropdown.handleClickOutside = (dotNetHelper, elementId) => {
    const element = document.getElementById(elementId);

    const handleClickOutside = (event) => {
        if (element && !element.contains(event.target)) {
            dotNetHelper.invokeMethodAsync('OnClickOutsideAsync');
        }
    };

    if (element) {
        document.addEventListener('click', handleClickOutside);
    }

    return () => document.removeEventListener('click', handleClickOutside);
};